import React from "react";

import { FaqBlocks } from "components/faq-blocks";
import Heading from "components/heading";
import HeroSection from "components/hero-section";

const faqs = [
  {
    question: "What is the Enerflo Solar Financing Operating System?",
    answer:
      "Enerflo is the solar financing operating system and origination platform — the infrastructure layer that banks, credit unions, capital providers, solar lenders, and TPO financiers use to run their entire solar financing program. It provides origination, credit decisioning, e-signature, homeowner portal, milestone tracking, risk monitoring, and portfolio intelligence in a single environment. Unlike a standalone LOS or a third-party portal bolted onto another tool, Enerflo's operating system is the complete foundation your program runs on.",
  },
  {
    question: "Is Enerflo compliant for regulated banks and financial institutions?",
    answer:
      "Yes. Enerflo is SOC 2 Type II certified, making it suitable infrastructure for banks, credit unions, and regulated solar lending institutions. Full transaction-level data is available via API or direct portal access for compliance audits.",
  },
  {
    question: "Who is Enerflo's solar financing operating system built for?",
    answer:
      "Enerflo's solar financing infrastructure is purpose-built for banks and credit unions offering solar loans, capital providers and solar lenders deploying residential solar financing, and TPO financiers — companies offering solar leases, PPAs, or pre-paid PPAs through a dealer and EPC installer network.",
  },
  {
    question: "Can a solar financier run a white-labeled program on Enerflo?",
    answer:
      "Yes. Enerflo supports fully white-label solar lending and TPO deployment — every homeowner interaction, solar contract, and project portal runs under your brand, not Enerflo's. It also supports native embedding inside existing EPC workflows for solar installers already on Enerflo, so your financing product surfaces without a separate portal or retraining requirement. This makes Enerflo the leading white-label solar financing platform for banks, credit unions, capital providers, solar lenders, and TPO financiers entering residential solar.",
  },
  {
    question: "What is a Loan Origination System (LOS) and does Enerflo include one?",
    answer:
      "A solar LOS (loan origination system) is the software that manages the full solar loan application workflow — from credit application and soft-pull decisioning through stipulation management, document generation, and e-signature. Enerflo's Solar Financing Operating System (SFOS) functions just like an LOS, but for every type of residential solar financing — loans, TPO leases, PPAs, and prepaid PPAs — not just loans. Origination is one of eight integrated capability categories, connected natively to the installer platform, compliance infrastructure, and portfolio analytics layer.",
  },
  {
    question: "What is an EPC dealer network in residential solar financing?",
    answer:
      "An EPC (Engineering, Procurement, and Construction) dealer network is the network of solar installation companies that originate and install residential solar projects funded by a solar lender or TPO provider. Enerflo's solar financing platform includes access to a nationwide EPC dealer network giving capital providers an immediate origination channel without recruiting installers from scratch.",
  },
  {
    question: "How quickly can a solar financier go live on Enerflo?",
    answer:
      "Most solar financiers go live on Enerflo's solar financing platform in weeks, not months. Integration engineering hours are covered by Enerflo — no hourly invoices for the build. Access to a nationwide EPC dealer network begins on day one, so origination volume can start immediately after launch.",
  },
  {
    question: "How does the 48E Investment Tax Credit (ITC) affect TPO solar financing in 2026?",
    answer:
      "With the residential solar tax credit (Section 25D) expiring at the end of 2025, TPO solar financing has become the primary pathway for homeowners to access federal solar incentives in 2026. TPO providers — solar leasing companies and PPA providers — can still claim the commercial 48E Investment Tax Credit through 2027, making a robust TPO origination and portfolio management platform like Enerflo increasingly critical for solar funds and capital providers structuring lease and PPA programs.",
  },
  {
    question: "What solar finance product types does Enerflo support?",
    answer:
      "Enerflo's solar financing operating system supports Solar Loans, Solar Leases, Solar Power Purchase Agreements (PPAs), and Pre-Paid PPAs — all product types in a single infrastructure layer, with no separate integrations required per product.",
  },
  {
    question:
      "What is the difference between a loan origination system (LOS) and a solar financing operating system (SFOS)?",
    answer:
      "A solar LOS handles one product (loans) and one workflow (origination — credit applications, decisioning, and documents). A Solar Financing Operating System (SFOS) like Enerflo covers every residential solar finance product — loans, TPO leases, PPAs, and prepaid PPAs — across every operational category a bank, credit union, capital provider, solar lender, or TPO financier needs: origination, operational backend, risk monitoring, security and compliance, data and portfolio reporting, project management and monitoring, API infrastructure, and a free EPC installer platform. The SFOS is the full infrastructure layer; the LOS is one component within it.",
  },
];

const title = "Frequently Asked Questions";

const FaqSection = () => {
  return (
    <HeroSection title={title} className="bg-white">
      <HeroSection.Content>
        <div className="text-center mb-12">
          <HeroSection.Tagline className="text-primary mb-4">{title}</HeroSection.Tagline>
          <Heading tag="h2" className="max-w-5xl mx-auto">
            <span>Solar loan origination, TPO financing & residential solar — </span>
            <span className="text-primary">questions from banks, credit unions & capital providers</span>
          </Heading>
        </div>

        <FaqBlocks items={faqs} />
      </HeroSection.Content>
    </HeroSection>
  );
};

export default FaqSection;
